
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import DocIcon from '../icons/DocIcon.vue';
import { GlobalBusNames } from '@/templates/DataNames';
import GlobalBus from '@/plugins/GlobalBus';
import Clipboard from '@/plugins/Clipboard';

export default defineComponent({
  name: 'CopyUrlButton',
  components: {
    DocIcon,
  },
  props: {
    anchor: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const isCopied = ref(false);
    const isMobile = ref(false);

    const copyToClipboard = () => {
      isCopied.value = true;
      Clipboard.copy(
        `${window.location.origin}${window.location.pathname}${
          props.anchor ? `#${props.anchor}` : ''
        }`
      );
      GlobalBus.emit(GlobalBusNames.COPIEDTOCLIPBOARD, props.anchor);
      setTimeout(() => (isCopied.value = false), 2000);
    };

    onMounted(() => {
      GlobalBus.on(GlobalBusNames.COPIEDTOCLIPBOARD, (val: string) => {
        if (props.anchor !== val) isCopied.value = false;
      });
      GlobalBus.on(
        GlobalBusNames.ISMOBILE,
        (isMobileVal: boolean) => (isMobile.value = isMobileVal)
      );
    });

    onBeforeUnmount(() => {
      GlobalBus.off(GlobalBusNames.COPIEDTOCLIPBOARD);
    });

    return {
      isCopied,
      isMobile,
      copyToClipboard,
    };
  },
});
